// extracted by mini-css-extract-plugin
export default {"sliders":"imgSlider_sliders__adfQb","slider":"imgSlider_slider__5qAvM"};